import axios from "axios";
import clevertap from "clevertap-web-sdk";
import moment from "moment";
import { compareDates, customDates, format, inBetweenDates } from "multi-date";
import { useContext, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import MetaTags from "react-meta-tags";

// scss
import "./style.scss";

// components
import BookingDetails from "components/ListingNew/ListingNormal/BookingDetails";
import ListingBreadcrumbs from "components/ListingNew/ListingNormal/ListingBreadCrumbs";
import ListingContent from "components/ListingNew/ListingNormal/ListingContent";
import ListingMetaTags from "components/ListingNew/ListingNormal/ListingMetaTags";
import NavbarMobile from "components/ListingNew/ListingNormal/NavbarMobile";
import PhotoGrid from "components/ListingNew/ListingNormal/PhotoGrid";

// named imports of components
import { SharePopup } from "components/CollectionDetails/SharePopup";
import Footer from "components/Footer";
import { ListingDiscontinued } from "components/ListingNew/ListingNormal/ListingDiscontinued";
// import { RecommendationScrollMenu } from "components/ListingNew/ListingNormal/RecomendationScroll/RecomendationScrollMenu";
// import EmailLoginHandler from "components/LoginAndRegister/EmailLoginHandler";
// import Modal from "components/LoginAndRegister/Modal";
// import PhoneLoginHandler from "components/LoginAndRegister/PhoneLoginHandler";
import { NavbarAndSidebar } from "components/NavbarAndSidebar";

// context
import { ListingInterface } from "context/ListingData";
import useCreateBooking from "context/Mutations/createBooking";
import { UserContext } from "store";

// customHooks
import { useListingCalculations } from "customHooks/useListingCalculations";
import { useMediaQuery } from "customHooks/useMediaQuery";
import { useUser } from "customHooks/useUser";

// helpers
import HomeRecomendation from "components/Home/HomeRecomendation";
import EmailLoginHandler from "components/LoginAndRegister/EmailLoginHandler";
import Modal from "components/LoginAndRegister/Modal";
import PhoneLoginHandler from "components/LoginAndRegister/PhoneLoginHandler";
import { getBlockedDates } from "helpers/getBloackedDates";
import getImg from "helpers/getCloudinaryImage";
import { getTheBestValue } from "helpers/getTheBestValue";
import { useCheckSavePrice } from "helpers/useCheckSavePrice";
import { minNightsData } from "lib/min2NightsData";
import { RecommendationScrollMenu } from "./RecomendationScroll/RecomendationScrollMenu";
import { UnlockDiscount } from "./UnlockDiscount";
import PopUpDrawer from "components/UniversalURL/UniversalURLReviewHeader/NPS/PopUpDrawer";
import { ListingCollection } from "./ListingCollection";
import { getTheBestValue1 } from "helpers/getTheBestValue1";
import { useCheckSavePrice1 } from "helpers/useCheckSavePrice1";
import BookingDetailsFlow from "./BookingDetailsFlow";
import { useQuery } from "react-query";
import { goAxiosInstance } from "helpers/axiosInstance";
import { ThemeContext, XSeriesTheme, useTheme } from "../ListingTheme";

type PageProps = {
	id: string;
};

const ListingNormal = ({ id }: PageProps) => {
	// prettier-ignore
	// @ts-ignore
	const {
		data,
		childrenData,
		adultsData,
		roomsData,
		infantsData,
		newListingId,
		useViewInteraction,petData
	} = useContext<any>(ListingInterface);

	const visitsData = useQuery(["visits"], () => {
		return goAxiosInstance({
			url: `visits?id=${data.data?.listing_list?.id}
				`,
			method: "GET",
		});
	});
	// console.log(visitsData.data);

	const [searchParams, setSearchParams] = useSearchParams();

	const listingList = data?.data?.listing_list;

	const listingImg = data?.data?.images_list;
	const spotlist = data?.data?.sleeping_and_spotlist;
	const amenityList = data?.length > 0 && data?.data?.amenities_list;

	// const newContentObj = data?.data?.newContentObj.SPOT_IMAGES.2.CAPTIONs

	const title = `Book ${listingList?.num_similar_rooms} ${
		listingList.TYPE_FLAG === "MV" ? "Villa" : "Bedroom"
	} ${listingList?.file_reference?.split("-")[0]}
					${
						["k8irx9vahpgbwcot", "RTje4EQTKxbZ42aX", "LoCmds4BTkx7JL90"]
							.map((e) => e.toLowerCase())
							.includes(data.data?.listing_list?.id?.toLowerCase())
							? "Glamps"
							: "Villa"
					} in ${listingList?.location}`;
	const description =
		listingList?.seo_faq_ideal_for ||
		listingList?.short_description ||
		listingList?.description ||
		`Get the best deals for ${
			listingList?.file_reference?.split("-")[0]
		} Villa located in ${
			listingList?.location
		} only at SaffronStays. Plan your next Stay Today!`;
	const image = `https://ik.imagekit.io/5tgxhsqev/saffronstays-media/tr:w-1250,h-630,q-60/image/upload//${listingImg[0]}`;
	const keyword = listingList?.keywords;

	const [spl, setSpl] = useState(false);
	const useSearchQuery = () => {
		const { search } = useLocation();
		return useMemo(() => new URLSearchParams(search), [search]);
	};

	let query = useSearchQuery();

	//---constants
	const width = useMediaQuery();
	const breakpoint = 900;
	const isMobile = width < breakpoint;
	const navigate = useNavigate();

	//---breadcrumbs
	const breadcrumbs = [
		{
			name: "Home",
			link: "/",
		},
		{
			name: "Search Results",
			link: `/villas/villas-in-${listingList?.city}?checkin=&checkout=&guests=&rooms=&lat=${listingList?.LATITUDE}&lon=${listingList?.LONGITUDE}`,
		},
	];

	//---date related stuff
	const {
		state: { datesToReserve, currentUser },
	} = useContext(UserContext);

	const [dates, setDates] = useState({
		checkin:
			query?.get("checkin") && query?.get("checkin") !== "null"
				? // @ts-ignore
				  new Date(query?.get("checkin"))
				: "",
		checkout:
			query?.get("checkout") && query?.get("checkout") !== "null"
				? // @ts-ignore
				  new Date(query?.get("checkout"))
				: "",
	});

	const [storeDates, setStoreDates] = useState([]);

	//---booking drawer stuff
	const [openDrawer, setOpenDrawer] = useState(false);

	//---login popup stuff
	const [showLoginPopup, setShowLoginPopup] = useState(false);

	const [phone, setPhone] = useState(true);

	//calculation of total amount after selecting rooms and guests

	const getCalendarData = async () => {
		const checkout = customDates(format(new Date(), "YYYY-MM-DD"), 1, "year");
		let data = await axios(
			`https://go.saffronstays.com/api/calendar/php/fetch-calendar?listing_id=${
				newListingId || id
			}&from_date=${format(new Date(), "YYYY-MM-DD")}&to_date=${format(
				checkout,
				"YYYY-MM-DD",
			)}`,
		);
		const resData = data.data[newListingId || id];
		// @ts-ignore
		const arr = {};
		Object.keys(resData).forEach((ele) => {
			// @ts-ignore
			arr[ele] = {
				...resData[ele],
				price: resData[ele].price
					? (parseInt(resData[ele].price) * parseInt(roomsData)).toString()
					: "",
			};
		});
		// @ts-ignore
		setStoreDates(arr);
	};

	useEffect(() => {
		if (roomsData !== 0) getCalendarData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [roomsData]);

	const { calculations, calLoading, calError } = useListingCalculations({
		// numGuests: guestsData?.guests,
		numChildren: childrenData,
		numInfants: infantsData,
		numAdults: adultsData,
		numRooms: roomsData,
		id: newListingId || id,
		dates: dates,
		numPet: petData,
	});

	const user = useUser();

	// creating booking
	const mutation = useCreateBooking();

	const onCreateBooking = () => {
		// @ts-ignore
		// const source = JSON.parse(localStorage.getItem("TRAFFIC_SOURCE"));
		if (!user) {
			if (isMobile) {
				// true for mobile device
				setShowLoginPopup(true);
				localStorage.setItem("booknow", "true");
				// navigate("/login");
			} else {
				// false for not mobile device
				setShowLoginPopup(true);
				localStorage.setItem("booknow", "true");
			}
		} else {
			// @ts-ignore
			mutation.mutate({
				LISTING_ID: newListingId || id,
				NUM_ROOMS: roomsData,
				// @ts-ignore
				FROM_DATE: moment(dates.checkin).format("YYYY-MM-DD"),
				// @ts-ignore
				TO_DATE: moment(dates.checkout).format("YYYY-MM-DD"),
				NUM_ADULTS: adultsData,
				NUM_CHILD: childrenData,
				NUM_INFANTS: infantsData,
				NUM_PETS: petData,
				// TRAFFIC_SOURCE:
				// 	source && source?.length > 0 ? source[source.length - 1] : "",
				UTM_SOURCE: localStorage.getItem("utm_source")
					? // @ts-ignore
					  localStorage.getItem("utm_source")
					: "",
				UTM_MEDIUM:
					localStorage.getItem("utm_medium") !== null
						? // @ts-ignore
						  localStorage.getItem("utm_medium")
						: "",
				UTM_CAMPAIGN:
					localStorage.getItem("utm_campaign") !== null
						? // @ts-ignore
						  localStorage.getItem("utm_campaign")
						: "",
				UTM_TERM:
					localStorage.getItem("utm_term") !== null
						? // @ts-ignore
						  localStorage.getItem("utm_term")
						: "",
				UTM_CONTENT:
					localStorage.getItem("utm_content") !== null
						? // @ts-ignore
						  localStorage.getItem("utm_content")
						: "",
				initial_referrer:
					localStorage.getItem("INITIAL_REFERRER") !== null
						? localStorage.getItem("INITIAL_REFERRER")
						: "",
				final_referrer:
					localStorage.getItem("UPDATED_REFERRER") !== null
						? localStorage.getItem("UPDATED_REFERRER")
						: "",
			});
		}
	};

	useEffect(() => {
		// @ts-ignore
		const source = JSON.parse(localStorage.getItem("TRAFFIC_SOURCE"));
		if (user && localStorage.getItem("booknow") === "true") {
			// @ts-ignore
			mutation.mutate({
				LISTING_ID: newListingId || id,
				NUM_ROOMS: roomsData,
				// @ts-ignore
				FROM_DATE: moment(dates.checkin).format("YYYY-MM-DD"),
				// @ts-ignore
				TO_DATE: moment(dates.checkout).format("YYYY-MM-DD"),
				NUM_ADULTS: adultsData,
				NUM_CHILD: childrenData,
				NUM_INFANTS: infantsData,
				// @ts-ignore
				TRAFFIC_SOURCE:
					source && source?.length > 0 ? source[source.length - 1] : "",
				UTM_SOURCE: localStorage.getItem("utm_source")
					? localStorage.getItem("utm_source")
					: "",
				UTM_MEDIUM:
					localStorage.getItem("utm_medium") !== null
						? localStorage.getItem("utm_medium")
						: "",
				UTM_CAMPAIGN:
					localStorage.getItem("utm_campaign") !== null
						? localStorage.getItem("utm_campaign")
						: "",
				UTM_TERM:
					localStorage.getItem("utm_term") !== null
						? // @ts-ignore
						  localStorage.getItem("utm_term")
						: "",
				UTM_CONTENT:
					localStorage.getItem("utm_content") !== null
						? // @ts-ignore
						  localStorage.getItem("utm_content")
						: "",
			});
		}
		localStorage.setItem("booknow", "false");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user]);

	useEffect(() => {
		mutation.reset();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dates]);

	const [blocked, setBlocked] = useState([]);
	const [blockedTemp, setBlockedTemp] = useState([]);

	const getBlockedDate = async () => {
		setBlocked(
			// @ts-ignore
			await getBlockedDates(
				newListingId ? newListingId : id,
				roomsData,
				storeDates,
			),
		);
		// if (blockedTemp.length === 0) {
		setBlockedTemp(
			// @ts-ignore
			await getBlockedDates(
				newListingId ? newListingId : id,
				roomsData,
				storeDates,
			),
		);
		// }
	};

	useEffect(() => {
		if (roomsData && storeDates.length !== 0) getBlockedDate();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [roomsData]);

	useEffect(() => {
		if (storeDates.length !== 0) getBlockedDate();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [storeDates]);

	const handleButtonClick = () => {
		if (Object.keys(calculations).length > 0 && !calError) {
			onCreateBooking();
			setOpenDrawer(false);
			// @ts-ignore
			// document.querySelector(".LandbotLivechat").style.display = "block";
		} else {
			// @ts-ignore
			// document.querySelector(".LandbotLivechat").style.display = "none";
			setOpenDrawer(true);
		}
	};
	// useEffect(() => {
	// 	let QueryDates = {
	// 		checkin: "",
	// 		checkout: "",
	// 	};
	// 	if (
	// 		query?.get("checkin") &&
	// 		query?.get("checkin") !== "null" &&
	// 		// @ts-ignore
	// 		!isNaN(query?.get("checkin"))
	// 	) {
	// 		// @ts-ignore
	// 		QueryDates.checkin = query?.get("checkin");
	// 	}
	// 	if (
	// 		query?.get("checkout") &&
	// 		query?.get("checkout") !== "null" &&
	// 		// @ts-ignore
	// 		!isNaN(query?.get("checkout"))
	// 	) {
	// 		// @ts-ignore
	// 		QueryDates.checkout = query?.get("checkout");
	// 	}
	// 	setDates({
	// 		checkin: new Date(QueryDates.checkin),
	// 		checkout: new Date(QueryDates.checkout),
	// 	});
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, []);

	useEffect(() => {
		if (dates.checkin) {
			searchParams.set("checkin", format(dates.checkin, "YYYY-MM-DD"));
			setSearchParams(searchParams, { replace: true });
		}
		if (dates.checkout) {
			searchParams.set("checkout", format(dates.checkout, "YYYY-MM-DD"));
			setSearchParams(searchParams, { replace: true });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dates]);

	useEffect(() => {
		if (roomsData) {
			searchParams.set("rooms", roomsData);
			setSearchParams(searchParams, { replace: true });
		}
		if (childrenData) {
			searchParams.set("children", childrenData);
			setSearchParams(searchParams, { replace: true });
		}
		if (adultsData) {
			searchParams.set("adults", adultsData);
			setSearchParams(searchParams, { replace: true });
		}
		if (infantsData) {
			searchParams.set("infants", infantsData);
			setSearchParams(searchParams, { replace: true });
		}
	}, [
		childrenData,
		adultsData,
		roomsData,
		infantsData,
		searchParams,
		setSearchParams,
	]);

	const getBetweenDates = (start: any) => {
		let arr = [];
		for (let i = 1; i < 100; i++) {
			arr.push(format(customDates(start, i, "day"), "YYYY-MM-DD"));
		}
		return arr;
	};

	const getNextBlockDate = (d: any) => {
		let i;
		for (i = 0; i < blockedTemp.length; i++) {
			if (compareDates(blockedTemp[i], d) === -1) {
				return i;
			}
		}
		return 0;
	};

	const calculateBlockedDates = (flag = 1) => {
		let tempArr = [...blockedTemp];
		for (let i = 1; i <= 30; i++) {
			let checkIn = format(customDates(dates.checkin, i, "day"), "YYYY-MM-DD");

			if (
				// @ts-ignore
				tempArr.includes(checkIn) ||
				// @ts-ignore
				minNightsData(newListingId ? newListingId : id).includes(
					format(dates.checkin, "YYYY-MM-DD"),
				)
			) {
				// @ts-ignore
				let indx = tempArr.indexOf(checkIn);
				const t = tempArr.splice(indx, 1);

				if (flag === 1) {
					const nextDay = customDates(dates.checkin, 1, "day");
					if (
						// @ts-ignore
						minNightsData(newListingId ? newListingId : id).includes(
							format(dates.checkin, "YYYY-MM-DD"),
						) &&
						tempArr.includes(
							// @ts-ignore
							format(customDates(dates.checkin, 2, "day"), "YYYY-MM-DD"),
						)
					) {
						if (
							!blockedTemp.includes(
								// @ts-ignore
								format(customDates(dates.checkin, 1, "day"), "YYYY-MM-DD"),
							)
						) {
							setSpl(true);
							// @ts-ignore
							setBlocked([
								...tempArr.splice(0, getNextBlockDate(dates.checkin)),
								format(nextDay, "YYYY-MM-DD"),
								...getBetweenDates(
									format(customDates(dates.checkin, 2, "day"), "YYYY-MM-DD"),
								),
							]);
						}
						// @ts-ignore
						else setBlocked([...tempArr.slice(0, indx), ...getBetweenDates(t)]);
					} else if (
						// @ts-ignore
						minNightsData(newListingId ? newListingId : id).includes(
							format(dates.checkin, "YYYY-MM-DD"),
						) &&
						// @ts-ignore
						!tempArr.includes(format(nextDay, "YYYY-MM-DD"))
					) {
						// @ts-ignore
						if (blockedTemp.includes(format(nextDay, "YYYY-MM-DD"))) {
							// @ts-ignore
							setBlocked([...tempArr.slice(0, indx), ...getBetweenDates(t)]);
						} else {
							setSpl(true);
							if (getNextBlockDate(dates.checkin)) {
								// @ts-ignore
								setBlocked([
									// @ts-ignore
									...tempArr.slice(0, getNextBlockDate(dates.checkin)),
									// @ts-ignore
									format(nextDay, "YYYY-MM-DD"),
									// @ts-ignore
									...getBetweenDates(tempArr[getNextBlockDate(dates.checkin)]),
								]);
							} else {
								// @ts-ignore
								setBlocked([
									// @ts-ignore
									...tempArr.slice(0, indx),
									// @ts-ignore
									format(nextDay, "YYYY-MM-DD"),
									// @ts-ignore	...tempArr.slice(0, indx),
									...tempArr.slice(indx, tempArr.length - 1),
								]);
							}
						}
					}
					// @ts-ignore
					else setBlocked([...tempArr.slice(0, indx), ...getBetweenDates(t)]);
				} else {
					setSpl(false);
					setBlocked([
						...tempArr.slice(0, indx),
						...tempArr.slice(indx, tempArr.length - 1),
					]);
				}
				break;
			}
		}
	};

	useEffect(() => {
		if (storeDates.length !== 0) {
			if (!dates.checkin) {
				getBlockedDate();
			} else if (dates.checkin && !dates.checkout) {
				calculateBlockedDates();
			} else if (dates.checkin && dates.checkout) {
				calculateBlockedDates(0);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dates]);

	useEffect(() => {
		if (
			format(dates.checkin, "YYYY-MM-DD") ===
			format(dates.checkout, "YYYY-MM-DD")
		) {
			setDates({
				// @ts-ignore
				checkin: "",
				// @ts-ignore
				checkout: "",
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dates.checkout]);

	useEffect(() => {
		useViewInteraction.mutate();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [localStorage.getItem("ip")]);

	// listing videos
	const isVideoAvailable = data?.data?.listing_videos?.length > 0;
	const videos = data?.data?.listing_videos;

	// share popup
	const [openSharePopup, setOpenSharePopup] = useState(false);
	const img = listingImg[0];
	const name = listingList.file_reference?.split("-")[0];
	const bedrooms = listingList?.no_similar_rooms;

	const isNotDilisted =
		(listingList?.status === "L" || listingList?.status === "P") && true;

	const parseIdAndVersion = (str: any) => {
		let img = {};
		// @ts-ignore
		[img.version, img.ImgId] = str
			?.slice(str.indexOf("uploads/") + 8, str.indexOf("_full"))
			?.split("_");

		const src = getImg({
			// @ts-ignore
			id: img.ImgId,
			// @ts-ignore
			version: img.version,
			quality: "80",
			width: "800",
			height: "460",
		});

		return src;
	};

	const parseSpotlightsData = (data: any) => {
		if (!data) return [];
		data = Object.values(data);
		// @ts-ignore
		let spotlights = [];

		// @ts-ignore
		data.forEach((v) => {
			spotlights.push({
				image: parseIdAndVersion(v.image.IMAGE_URL_FULL),
				description: v.caption,
			});
		});
		// @ts-ignore
		return spotlights;
	};

	const spotlights = parseSpotlightsData(
		data?.data?.sleeping_and_spotlist?.spot_images,
	);

	const spotlightObject = {
		spotlightImage1: spotlights[0]?.image?.IMAGE_ID,
		spotlightHeader1: spotlights[0]?.caption,
		spotlightImage2: spotlights[1]?.image?.IMAGE_ID,
		spotlightHeader2: spotlights[1]?.caption,
	};

	useEffect(() => {
		// @ts-ignore
		let srciptDOM;

		// @ts-ignore
		let fbScript;
		if (document) {
			clevertap.event.push("view_listing_page", {
				currency: "INR",
				value: `${listingList?.per_night_charge}`,
				listing_id: `${listingList?.id}`,
				listing_name: `${listingList?.file_reference}`,
				listing_image: `https://ik.imagekit.io/5tgxhsqev/saffronstays-media/tr:w-400,h-400,q-56/image/upload/${data?.data?.images_list[0]}`,
				listing_location: `${listingList?.location}`,
				item_brand: `${listingList?.state}`,
				item_category: `${listingList?.city}`,
				item_category2: `${listingList?.signature}`,
				// item_category3: `${listingList?.min_rooms}`,
				// item_category4: `${Object.keys(amenityList).includes("36")}`,
				item_category5: `${Object.keys(amenityList).includes("19")}`,
				// item_variant: `${listingList?.TYPE_FLAG}`,
				price: `${listingList?.per_night_charge}`,
				high_demand_message:
					visitsData?.data?.data?.data?.VALUE >= 50 &&
					`${visitsData?.data?.data?.data?.VALUE} Travelers saw this property in the last few hours`,
				// quantity: `${inBetweenDates(dates.checkin, dates.checkout)}`,
				...spotlightObject,
				view_count: visitsData?.data?.data?.data?.VALUE,
			});

			srciptDOM = document.createElement("script");
			srciptDOM.innerHTML = `gtag("event", "view_item", {
						currency: "INR",
						value: "${listingList?.per_night_charge}",
						items: [{
							item_id: "${listingList?.id}",
							item_name: "${listingList?.file_reference}",
							item_brand: "${listingList?.state}",
							item_category: "${listingList?.city}",
							item_category2: "${listingList?.signature}",
							item_category3: "${listingList?.min_rooms}",
							item_category4: "${Object.keys(amenityList).includes("36")}",
							item_category5: "${Object.keys(amenityList).includes("19")}",
							item_variant: "${listingList?.TYPE}",
							price: "${listingList?.per_night_charge}",
							quantity: "${inBetweenDates(dates.checkin, dates.checkout)}"
						}]
					});`;
			srciptDOM.defer = true;
			document.head.appendChild(srciptDOM);

			fbScript = document.createElement("script");
			// fbScript.innerHTML = `fbq('track', 'ViewContent', { value: '${
			// 	listingList?.per_night_charge
			// }', currency: 'INR', content_ids: '${listingList?.id}', city: '${
			// 	listingList?.city
			// }', region:'${
			// 	listingList?.state
			// }', country:'India', content_type: 'hotel', checkin_date:'${query?.get(
			// 	"checkin",
			// )}', checkout_date:'${query?.get("checkout")}', num_adults:'${query?.get(
			// 	"adults",
			// )}', num_children:'${query?.get("children")}' });`;
			fbScript.innerHTML = `fbq('track', 'ViewContent', {
    value: '${listingList?.per_night_charge}',
    currency: 'INR',
    content_id: '${listingList?.id}',
    city: '${listingList?.city} ',
    region: '${listingList?.state}',
    country: 'India',
    content_type: 'hotel',
    checkin_date: '${query?.get("checkin")}',
    checkout_date: '${query?.get("checkout")}',
    num_adults: '${query?.get("adults")}',
    num_children: '${query?.get("children")}'
})`;
			fbScript.defer = true;
			document.head.appendChild(fbScript);
		}
		return () => {
			// @ts-ignore
			document.head.removeChild(srciptDOM);

			// @ts-ignore
			document.head.removeChild(fbScript);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const [bestVal, setBestVal] = useState({});
	const [sortArrVal, setSortArrVal] = useState([]);
	// const [newDates, setNewDates] = useState({});

	const [newDatesGst, setNewDateGst] = useState({
		checkin: "",
		checkout: "",
	});

	// useEffect(() => {
	// 	const checkinDay = moment(dates.checkin).day();
	// 	const checkoutDay = moment(dates.checkout).day();

	// 	const checkDiffIn = moment(dates.checkin);
	// 	const checkDiffOut = moment(dates.checkout);
	// 	const dateDiff = Math.abs(checkDiffIn.diff(checkDiffOut, "days"));

	// if (dateDiff === 2) {
	// } else {
	// 	// if (
	// 	// 	(checkinDay === 5 || checkinDay === 6) &&
	// 	// 	(checkoutDay === 7 ||
	// 	// 		checkoutDay === 1 ||
	// 	// 		checkoutDay === 2 ||
	// 	// 		checkoutDay === 0 ||
	// 	// 		checkoutDay === 6)
	// 	// ) {
	// 	// 	const val = getTheBestValue(storeDates, dates.checkin, dates.checkout);
	// 	// 	setBestVal(val);
	// 	// 	const lowestPrice = val && Object?.keys(val).map((v) => +v);
	// 	// 	setSortArrVal(lowestPrice);
	// 	// } else {
	// 	// 	setNewDate({ checkin: "", checkout: "" });
	// 	// }

	// }

	// if (dateDiff <= 0) {
	// } else {
	// 	const val = getTheBestValue1(
	// 		storeDates,
	// 		moment(dates.checkin).format("YYYY-MM-DD"),
	// 		moment(dates.checkout).add(1, "day").format("YYYY-MM-DD"),
	// 	);
	// 	setBestVal(val);
	// 	const lowestPrice = val && Object?.keys(val).map((v) => +v);
	// 	setSortArrVal(lowestPrice);
	// 	;
	// }
	// }, [dates.checkin, dates.checkout, storeDates]);

	// @ts-ignore
	const { newCalculations } = useCheckSavePrice({
		bestVal: bestVal,
		sortArrVal: sortArrVal,
		calculationsOld: calculations,
		childrenData: childrenData,
		infantsData: infantsData,
		adultsData: adultsData,
		roomsData: roomsData,
		setNewDate: undefined,
		newDates: undefined,
		id: newListingId || id,
		petData: petData,
	});

	const [newDates, setNewDate] = useState({
		checkin: moment(dates.checkin).format("YYYY-MM-DD"),
		checkout: moment(dates.checkout).add(1, "day").format("YYYY-MM-DD"),
	});

	useEffect(() => {
		setNewDate({
			checkin: moment(dates.checkin).format("YYYY-MM-DD"),
			checkout: moment(dates.checkout).add(1, "day").format("YYYY-MM-DD"),
		});
	}, [dates]);

	// @ts-ignore
	const { prevCalculations, newCalError } = useCheckSavePrice1({
		// numGuests: guestsData?.guests,
		childrenData: childrenData,
		infantsData: infantsData,
		adultsData: adultsData,
		roomsData: roomsData,
		id: newListingId || id,
		newDates: newDates,
		dates: dates,
		oldDates: dates,
		petData: petData,
		setNewDate: setNewDate,
	});

	useEffect(() => {
		if (newCalError) {
			setNewDate({
				checkin: moment(dates.checkin).add(-1, "day").format("YYYY-MM-DD"),
				checkout: moment(dates.checkout).format("YYYY-MM-DD"),
			});
		}
	}, [newCalError]);

	const { state, dispatch } = useContext(UserContext);

	const [guestImg, setGuestImg] = useState([]);
	const getGuestImage = async () => {
		const res = await axios(
			`https://ecapi.saffronstays.com/share-memories/get?LISTING_ID=${
				newListingId || id
			}&per_page=100`,
		);
		if (res.data.success) {
			setGuestImg(res.data.data.memories);
		}
	};
	useEffect(() => {
		getGuestImage();
	}, []);

	const theme = useTheme();

	return (
		<>
			<MetaTags>
				<title>{title}</title>
				<meta name="keywords" content={keyword} />
				<meta name="description" content={description} />

				<meta property="og:type" content="website" />
				<meta property="og:title" content={title} />
				<meta property="og:description" content={description} />
				<meta property="og:image" content={image} />
				<meta property="og:url" content={window.location.href} />

				<meta property="twitter:url" content={window.location.href} />
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:image:alt" content={image} />
				{/* <script defer>
					{`
					gtag("event", "view_item", {
						currency: "INR",
						value: "${listingList?.PER_NIGHT_CHARGE}",
						items: [{
							item_id: "${listingList?.ID}",
							item_name: "${listingList?.FILE_REFERENCE}",
							item_brand: "${listingList?.STATE}",
							item_category: "${listingList?.villaCity}",
							item_category2: "${listingList?.SIGNATURE}",
							item_category3: "${listingList?.MIN_ROOMS}",
							item_category4: "${Object.keys(amenityList).includes("36")}",
							item_category5: "${Object.keys(amenityList).includes("19")}",
							item_variant: "${listingList?.TYPE}",
							price: "${listingList?.PER_NIGHT_CHARGE}",
							quantity: "${inBetweenDates(dates.checkin, dates.checkout)}"
						}]
					});

				`}
				</script> */}
				<script defer>
					{`fbq('track', "view_item", {
						currency: "INR",
						value: "${listingList?.per_night_charge}",
						items: [{
							item_id: "${listingList?.id}",
							item_name: "${listingList?.file_reference}",
							item_brand: "${listingList?.state}",
							item_category: "${listingList?.city}",
							item_category2: "${listingList?.signature}",
							item_category3: "${listingList?.min_rooms}",
							item_category4: "${Object.keys(amenityList).includes("36")}",
							item_category5: "${Object.keys(amenityList).includes("19")}",
							item_variant: "${listingList?.TYPE_FLAG}",
							price: "${listingList?.per_night_charge}",
							quantity: "${inBetweenDates(dates.checkin, dates.checkout)}"
						}]
					});`}
				</script>

				<link
					rel="canonical"
					href={`https://www.saffronstays.com/view/${data?.meta?.seo_url}-${listingList?.id}`}
				/>
			</MetaTags>
			{query.get("rooms") === null && query.get("adults") === null && (
				<ListingMetaTags
					title={title}
					description={description}
					imageUrl={image}
					keyword={keyword}
					listingList={listingList}
					amenityList={amenityList}
					listingImg={listingImg}
					// @ts-ignore
					dates={dates}
					meta={data?.meta}
				/>
			)}
			{isMobile ? (
				<NavbarMobile
					name={listingList?.FILE_REFERENCE?.split("-")[0]}
					listingList={listingList}
					link={breadcrumbs[1].link}
					image={`https://ik.imagekit.io/5tgxhsqev/saffronstays-media/tr:w-1250,h-630,q-60/image/upload//${listingImg[0]}`}
					// @ts-ignore
					price={calculations?.defaultTotalTariffWithoutGst}
					openSharePopup={() => setOpenSharePopup(true)}
				/>
			) : (
				<NavbarAndSidebar
					link={breadcrumbs[1].link}
					isBackgroundTransparent={true}
				/>
			)}
			{!isNotDilisted ? (
				// Discontinued Listing
				<div
					style={{
						margin: "0 auto",
						maxWidth: "1260px",
						padding: "0 16px",
					}}
				>
					{!isMobile && (
						<ListingBreadcrumbs
							className={"listing__inner-wrapper"}
							items={breadcrumbs}
							name={listingList.file_reference}
							id={id}
						/>
					)}
					<ListingDiscontinued />
				</div>
			) : (
				// Continued Listing
				<div
					className="listing__outer-wrapper"
					style={{
						background: theme?.background,
					}}
				>
					{/* {!isMobile && (
						<ListingBreadcrumbs
							className={"listing__inner-wrapper"}
							items={breadcrumbs}
							name={listingList.file_reference}
							id={id}
						/>
					)} */}

					{datesToReserve.checkout && datesToReserve.checkin && isMobile && (
						<BookingDetails
							dates={datesToReserve}
							onClick={() => setOpenDrawer(true)}
						/>
					)}

					<PhotoGrid
						query={query}
						images={listingImg}
						isVideoAvaiable={isVideoAvailable}
						videos={videos}
						openSharePopup={() => setOpenSharePopup(true)}
						isPartnerHome={
							listingList?.share_scheme === "PARTNER" &&
							currentUser &&
							currentUser?.isTravelAgent
								? true
								: false
						}
						isMariott={Object.keys(data?.data?.amenities_list).includes("1")}
						isNext={false}
						listName={listingList.file_reference.split("-")[0]}
						className="listing__inner-wrapper"
						width={"1650"}
						height={"762"}
						quality={"80"}
						address={`${listingList.city}, ${listingList.state}`}
						isSignature={listingList?.signature === "Signature"}
						cancellation={listingList?.cancelltion === "FREECANCELLATION"}
						video360={data?.data?.sleeping_and_spotlist?.spot_info?.VIDEO_360}
						id={listingList?.id}
						guestImg={guestImg}
					/>

					{/* Listing content */}
					<ListingContent
						setShowLoginPopup={setShowLoginPopup}
						datesError={calError}
						// @ts-ignore
						dates={dates}
						// @ts-ignore
						setDates={setDates}
						blocked={blocked}
						onCreateBooking={onCreateBooking}
						calculations={calculations}
						calLoading={calLoading || mutation.isLoading}
						mutation={mutation}
						openSharePopup={() => setOpenSharePopup(true)}
						spl={spl}
						query={query}
						storedDates={storeDates}
						bestVal={bestVal}
						sortArrVal={sortArrVal}
						newCalculations={newCalculations}
						newDates={newDates}
						prevCalculations={prevCalculations}
						guestImg={guestImg}
					/>
				</div>
			)}
			{/* {isMobile ? (
				<FloatingButton bottom={"105px"} right={"0px"} />
			) : (
				<FloatingButton bottom={"20px"} right={"20px"} />
			)} */}
			<ListingCollection ids={spotlist.spot_info.collections} />
			{listingList?.id && <HomeRecomendation listingID={listingList?.id} />}
			<Footer />
			{isMobile && isNotDilisted && (
				<>
					<BookingDetailsFlow
						openDrawer={openDrawer}
						setOpenDrawer={setOpenDrawer}
						id={id}
						dates={dates}
						setDates={setDates}
						handleButtonClick={handleButtonClick}
						calculations={calculations}
						calLoading={calLoading || mutation.isLoading}
						calError={
							mutation.error
								? // @ts-ignore
								  typeof mutation.error?.response?.data?.error === "object"
									? // @ts-ignore
									  Object.values(mutation.error?.response?.data?.error)[0]
									: // @ts-ignore
									  mutation.error?.response?.data?.error
								: calError
						}
						blocked={blocked}
						spl={spl}
						storedDates={storeDates}
						newCalculations={newCalculations}
						newDates={newDates}
					/>
				</>
			)}
			{/* Login Modal */}
			{state.isFromBookingBtn ? (
				//@ts-ignore
				<PopUpDrawer open={showLoginPopup} setOpen={setShowLoginPopup}>
					<PhoneLoginHandler
						onRequestClose={() => setShowLoginPopup(false)}
						setPhone={setPhone}
					/>
				</PopUpDrawer>
			) : (
				<Modal
					shouldShow={showLoginPopup}
					onRequestClose={() => {
						dispatch({
							type: "FROM_BOOK_BUTTON",
							payload: false,
						});
						setShowLoginPopup(false);
					}}
				>
					{phone ? (
						<PhoneLoginHandler
							onRequestClose={() => setShowLoginPopup(false)}
							setPhone={setPhone}
						/>
					) : (
						<EmailLoginHandler
							onRequestClose={() => setShowLoginPopup(false)}
							setPhone={setPhone}
							phone={phone}
						/>
					)}
				</Modal>
			)}{" "}
			{/* Share Popup */}
			<Modal
				shouldShow={openSharePopup}
				onRequestClose={() => setOpenSharePopup(false)}
			>
				<SharePopup
					onRequestClose={() => setOpenSharePopup(false)}
					setopenSharePopup={setOpenSharePopup}
					img={img}
					name={name}
					bedrooms={bedrooms}
				/>
			</Modal>
			{/* Marcom script */}
			{/* {!isMobile && (
				<>
					<script src="https://apps.elfsight.com/p/platform.js" defer></script>
					<div className="elfsight-app-eb2e1f34-9a32-4652-bf59-7521b6434ec9"></div>
				</>
			)} */}
		</>
	);
};

export default ListingNormal;
